import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import type { KinerjaPraktikPembelajaranContentIndikator } from 'types/kinerja'
import type { FC } from 'react'

interface CardIndikatorDimensiProps extends React.HTMLProps<HTMLDivElement> {
  indikator: Partial<KinerjaPraktikPembelajaranContentIndikator>
  icon?: React.ReactNode
  isSelected?: boolean
  onSelected?: (selected: boolean) => void
  disabled?: boolean
}

const CardIndikatorDimensi: FC<CardIndikatorDimensiProps> = ({
  indikator,
  icon,
  isSelected = false,
  onSelected = () => {},
  disabled = false,
  className,
  ...divProps
}) => {
  const cardClasses = clsx(
    className,
    'max-w-[971px] select-none border border-subdued border-subdued rounded-lg',
    'hover:border-gray-30 hover:bg-blue',
    {
      '!bg-blue-5 !border-blue-70': isSelected,
      'cursor-pointer': !disabled,
      'bg-surface-subdued !cursor-not-allowed': disabled,
    }
  )

  const handleClick = () => {
    onSelected(!isSelected)
  }

  return (
    <div
      aria-selected={isSelected}
      className={cardClasses}
      data-testid="card"
      role="option"
      onClick={handleClick}
      {...divProps}
    >
      <div className="flex flex-row gap-4 p-4 items-center">
        <div className="flex-none">{icon}</div>

        <div className="flex-1 space-y-1">
          <Text variant="heading-sm">{indikator?.nama}</Text>
          <Text variant="body" color="subdued">
            {indikator?.definisi}
          </Text>
        </div>
      </div>
    </div>
  )
}
export default CardIndikatorDimensi
